import React, { useState } from 'react';
import axios from 'axios';

function SubdomainSection({ user, onUpdateUser }) {
  const [subdomain, setSubdomain] = useState(user?.subdomain || '');
  const [isEditing, setIsEditing] = useState(!user?.subdomain);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [copied, setCopied] = useState(false);
  const [linkActive, setLinkActive] = useState(user?.link_active !== false);
  const [toggling, setToggling] = useState(false);

  const handleSaveSubdomain = async () => {
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/api/user/subdomain', {
        subdomain: subdomain.toLowerCase()
      });

      onUpdateUser({ ...user, subdomain: response.data.subdomain });
      setIsEditing(false);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to save subdomain');
    } finally {
      setLoading(false);
    }
  };

  const handleToggleLink = async () => {
    setToggling(true);
    const newActiveState = !linkActive;

    try {
      await axios.post('/api/user/toggle-link', {
        active: newActiveState
      });

      setLinkActive(newActiveState);
      onUpdateUser({ ...user, link_active: newActiveState });
    } catch (err) {
      setError('Failed to toggle link status');
    } finally {
      setToggling(false);
    }
  };

  const handleCopyLink = () => {
    const link = `${user.subdomain}.jjm.app`;
    navigator.clipboard.writeText(link);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const fullUrl = user?.subdomain ? `${user.subdomain}.jjm.app` : null;

  return (
    <div className="subdomain-section">
      <div className="section-header">
        <h2 className="section-title">Your Link</h2>
        {user?.subdomain && !isEditing && (
          <button 
            className="btn-secondary"
            style={{ padding: '0.5rem 1rem', fontSize: '0.85rem' }}
            onClick={() => setIsEditing(true)}
          >
            Change
          </button>
        )}
      </div>

      {isEditing ? (
        <div>
          <div className="form-group">
            <label className="form-label">Choose Your Subdomain</label>
            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center', flexWrap: 'wrap' }}>
              <input
                type="text"
                className="form-input"
                placeholder="yourname"
                value={subdomain}
                onChange={(e) => setSubdomain(e.target.value.toLowerCase().replace(/[^a-z0-9-]/g, ''))}
                style={{ flex: '1', minWidth: '200px' }}
              />
              <span style={{ color: 'var(--muted-gray)', whiteSpace: 'nowrap' }}>.jjm.app</span>
            </div>
            <div style={{ fontSize: '0.85rem', color: 'var(--muted-gray)', marginTop: '0.5rem' }}>
              Only lowercase letters, numbers, and hyphens allowed
            </div>
          </div>

          {error && <div className="error-message">{error}</div>}

          <div className="form-actions">
            <button 
              className="btn-success" 
              onClick={handleSaveSubdomain}
              disabled={loading || !subdomain}
            >
              {loading ? 'Saving...' : 'Save Subdomain'}
            </button>
            {user?.subdomain && (
              <button 
                className="btn-cancel" 
                onClick={() => {
                  setIsEditing(false);
                  setSubdomain(user.subdomain);
                  setError('');
                }}
              >
                Cancel
              </button>
            )}
          </div>
        </div>
      ) : (
        <>
          {fullUrl ? (
            <>
              <div className="subdomain-display">
                <div className="subdomain-url">{fullUrl}</div>
                <button className="btn-copy" onClick={handleCopyLink}>
                  {copied ? '✓ Copied!' : 'Copy Link'}
                </button>
              </div>
              
              <div style={{ marginTop: '1rem', padding: '1rem', background: 'var(--card-bg)', borderRadius: '8px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <div style={{ fontWeight: '500', marginBottom: '0.25rem' }}>Link Status</div>
                    <div style={{ fontSize: '0.85rem', color: 'var(--muted-gray)' }}>
                      {linkActive ? 'Active - Link will download contact' : 'Inactive - Link redirects to Google'}
                    </div>
                  </div>
                  <button
                    onClick={handleToggleLink}
                    disabled={toggling}
                    className={linkActive ? 'btn-success' : 'btn-secondary'}
                    style={{ minWidth: '100px' }}
                  >
                    {toggling ? 'Updating...' : (linkActive ? 'Active' : 'Inactive')}
                  </button>
                </div>
              </div>
            </>
          ) : (
            <div style={{ color: 'var(--muted-gray)', padding: '1rem' }}>
              Set up your subdomain to get started
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default SubdomainSection;
